import AdyenBtn from '../../adyen-button';
import './card-button.scss';

const CardBtn = () => {
    return <AdyenBtn
        className='card-button'
        paymentType='card'
    />;
};

export default CardBtn;
